import utils from '@/utils/common';
import { isWeChatApplet } from '@/utils/util';
const deviceWidth =
  document.documentElement.clientWidth || document.body.clientWidth;
export function rem2px(val, unit = true) {
  if ((val = Number(val)) === 0 || isNaN(val)) return 0;
  const scale = deviceWidth / 750;
  const eps = 1e-4;
  return Math.floor(val * scale + eps) + (unit ? 'px' : 0);
}

/**
 * 校验是否绑定微信
 */
export function validateIsBindingWechat(vm) {
  return new Promise((resolve) => {
    vm.http({
      url: 'sys/social/getWeChatUserInfo',
      method: 'get'
    }).then(async ({ code, data }) => {
      if (code === 200) {
        if (data.bindStatus === 1 /*已绑定*/) {
          resolve();
        } else if (await isWeChatApplet()) { // 非小程序 
          vm.$dialog
            .confirm({
              title: '专属活动请先绑定微信',
              message: '点击将跳转微信绑定界面',
              confirmButtonColor: '#007AFF',
              cancelButtonColor: '#666666'
            })
            .then(() => {
              utils.bindWeChat();
            });
        } else { // 小程序
          const message =
            '小程序手机号注册登陆无法参与活动，因无法识别用户手机号归属\r\n' +
            '请用微信绑定的手机号授权登录参与活动\r\n' +
            '辅助说明：微信未授权手机号无法参与活动';
          vm.$dialog.alert({
            title: '提示',
            message,
            confirmButtonColor: '#007AFF',
            cancelButtonColor: '#666666'
          });
        }
      }
    });
  });
}
/**
 * @param {Number} id 活动id
 * @param {Number} type 活动类型 1用户领券 2秒杀活动
 * @returns { Promise }
 * @description 校验是否企微好友
 */
export function validateIsQwFriend(vm, id, type = 1) {
  return new Promise((resolve) => {
    const error = () => vm.$toast('服务异常，请稍候再试！');
    vm.http({
      url: 'order/coupon/checkIsQwFriend',
      method: 'post',
      parmes: {
        activityId: id,
        activityType: type
      }
    })
      .then(({ code, data }) => {
        if (code === 200 && data) {
          if (data.isQwFriend) {
            resolve();
          } else {
            let title = '用户：' + data.userPhone
            vm.$dialog.confirm({
              title,
              message: data.takePartType == 3 ? data.scopePromptInfo: data.noFriendInfo,
              confirmButtonText: data.takePartType == 3 ? '加入群聊':'添加客服',
              confirmButtonColor: '#007AFF',
              cancelButtonText: '暂不领取',
              cancelButtonColor: '#666666'
            }).then(async () => {
              if(await isWeChatApplet()) { // 非小程序
                utils.nativeMethod({
                  tm: 4100300,
                  tp: { guideUrl: data.appInvitPageUrl }
                });
              } else { // 小程序
                const params = `?from=h5user&imageUrl=${encodeURIComponent(data.appletInvitPageUrl)}`;
                wx.miniProgram.navigateTo({
                  url: '/userbase/pages/contact-salesman/index' + params
                })
              }
            });
          }
        } else {
          error();
        }
      })
      .catch(error);
  });
}
